module.exports = __webpack_public_path__ + "static/media/schwangerschaftsberatung.443c3c9d.jpg";